import ConsentBoxManager from './class/ConsentBoxManager';

export default () => {
  const GTM_ID = document.querySelector('meta[name="gtm-id"]')?.getAttribute('content');

  const cookieManager = new ConsentBoxManager();

  if (GTM_ID) {
    cookieManager.services.add({
      key: 'googletagmanager',
      type: 'ads',
      name: 'Google Tag Manager',
      uri: 'https://tagmanager.google.com',
      needConsent: true,
      cookies: ['AEC', 'APISID', 'HSID', 'NID', 'OTZ', 'SAPISID', 'SEARCH_SAMESITE', 'SID', 'SIDCC', 'SOCS', 'SSID'],
      js: function () {
        (function (w, d, s, l, i) {
          // @ts-expect-error - TS doesn't know about GTM
          w[l] = w[l] || [];
          // @ts-expect-error - TS doesn't know about GTM
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
          });
          var f = d.getElementsByTagName(s)[0], // eslint-disable-line
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          // @ts-expect-error - TS doesn't know about GTM
          j.async = true;
          // @ts-expect-error - TS doesn't know about GTM
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          // @ts-expect-error - TS doesn't know about GTM
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', GTM_ID);

        document.body.insertAdjacentHTML(
          'afterbegin',
          '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=' +
            GTM_ID +
            '"\n' +
            'height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>',
        );
      },
    });

    cookieManager.services.enable(['googletagmanager']);
  }

  cookieManager
    .init({
      websiteTitle: 'Ecodigo',
      locale: 'fr',
      // @ts-expect-error specialPages came from global const
      policyUri: specialPages && specialPages.policyUri !== '' ? specialPages.policyUri : null,
    })
    .then(() => console.log('CookieBoxManagerInitialized'));
};
